function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPocConvenienceStoreFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 14v13H4V14h2zm20 13V14h2v13h-2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 7a2 2 0 012-2h26a2 2 0 012 2v6a2 2 0 01-2 2H3a2 2 0 01-2-2V7zm2 0v6h26V7H3zM19 20h-6v6h6v-6zm-8-2v10h10V18H11z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 11h-7V9h7v2zM11 11H3V9h8v2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1 12v-.781l1.492-1.235c.099-.082.184-.158.254-.23a.873.873 0 00.164-.225.556.556 0 00.059-.256.498.498 0 00-.067-.263.43.43 0 00-.18-.168.563.563 0 00-.265-.06c-.1 0-.189.02-.266.06a.42.42 0 00-.175.178.599.599 0 00-.063.285h-1.031c0-.282.063-.524.19-.727.126-.203.304-.36.534-.469.23-.109.501-.164.81-.164.321 0 .599.052.833.155.236.101.417.244.545.43.129.184.193.401.193.65 0 .153-.032.306-.095.459a1.878 1.878 0 01-.344.502c-.166.183-.4.402-.705.656l-.375.312v.024h1.562V12H13.1zM16.53 11.375v-.844L18.14 8h.765v1.125h-.437l-.867 1.375v.031h2.375v.844H16.53zm1.946.625v-.883l.023-.367V8h1.016v4h-1.04z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 26.5V20h2v6.5h-2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 28H1v-2h30v2z",
    fill: props.color
  }));
}

export default SvgIconPocConvenienceStoreFilled;